<div libClickOutSide (clickOutside)="close()">
  <button
    type="button"
    id="side_menu_profile_button"
    [attr.aria-expanded]="isOpen()"
    [class]="
      'flex w-full items-center gap-sm rounded-md p-x-sm text-start hover:bg-neutral-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 ' +
      (collapsed() ? 'justify-center' : '') +
      (isOpen() ? ' bg-neutral-50' : '')
    "
    (click)="toggle()">
    <lib-avatar
      [fullName]="userName()"
      [img]="userImage()"
      imgClass="size-3xl rounded-full" />
    @if (!collapsed()) {
      <span class="flex min-w-0 flex-1 flex-col">
        <span class="truncate text-sm font-medium text-neutral-900">{{
          userName()
        }}</span>
        <span class="truncate text-xs text-neutral-500">{{
          workspaceName()
        }}</span>
      </span>
      <lib-chevron-right-icon iconClass="size-4 text-neutral-500" />
    } @else {
      <span class="sr-only">{{ userName() }}</span>
    }
  </button>

  @if (isOpen()) {
    <div
      data-profile-panel
      class="absolute bottom-6 start-full z-50 ms-sm w-72 rounded-lg border border-neutral-200 bg-white py-sm shadow-lg">
      <ul class="flex flex-col">
        <li class="relative">
          <button
            type="button"
            data-item="workspaces"
            [attr.aria-expanded]="popup() === 'workspaces'"
            class="flex w-full items-center gap-sm px-lg py-sm text-start text-sm text-neutral-700 hover:bg-neutral-50"
            (click)="openWorkspaces()">
            <span class="flex-1">{{
              'profile_menu_workspaces_label' | transloco
            }}</span>
            <span class="truncate text-xs text-neutral-500">{{
              workspaceName()
            }}</span>
            <lib-chevron-right-icon iconClass="size-4 text-neutral-500" />
          </button>
          @if (popup() === 'workspaces') {
            <div
              data-workspaces-popup
              class="absolute top-0 start-full z-10 ms-sm w-64 rounded-lg border border-neutral-200 bg-white py-sm shadow-lg">
              <p class="px-lg pb-x-sm pt-sm text-xs text-neutral-500">
                {{ 'profile_menu_workspaces_label' | transloco }}
              </p>
              @for (ws of workspaces(); track ws.slug) {
                <button
                  type="button"
                  [attr.data-workspace]="ws.slug"
                  [attr.aria-current]="ws.current ? 'true' : null"
                  class="flex w-full items-center gap-sm px-lg py-sm text-start text-sm hover:bg-neutral-50"
                  (click)="switchWorkspace(ws.slug)">
                  <lib-avatar
                    [fullName]="ws.name"
                    imgClass="size-2xl rounded-md" />
                  <span class="flex min-w-0 flex-1 flex-col"
                    ><span class="truncate font-medium text-neutral-900">{{
                      ws.name
                    }}</span
                    ><span class="truncate text-xs text-neutral-500">{{
                      ws.line
                    }}</span></span
                  >
                  @if (ws.current) {
                    <span class="text-neutral-900" aria-hidden="true">✓</span>
                  }
                </button>
              }
              <hr class="my-sm border-neutral-200" />
              <button
                type="button"
                data-create-workspace
                class="flex w-full px-lg py-sm text-start text-sm text-neutral-700 hover:bg-neutral-50"
                (click)="createWorkspace()">
                {{ 'profile_menu_create_workspace_label' | transloco }}
              </button>
            </div>
          }
        </li>
        <li>
          <a
            data-item="edit-profile"
            [routerLink]="editProfilePath"
            (click)="close()"
            class="flex px-lg py-sm text-sm text-neutral-700 hover:bg-neutral-50"
            >{{ 'profile_menu_edit_profile_label' | transloco }}</a
          >
        </li>
        <li>
          <a
            data-item="account-settings"
            [routerLink]="accountSettingsPath"
            (click)="close()"
            class="flex px-lg py-sm text-sm text-neutral-700 hover:bg-neutral-50"
            >{{ 'sidenav_account_item_label' | transloco }}</a
          >
        </li>
        <li
          data-item="language"
          class="flex items-center justify-between gap-md px-lg py-sm">
          <span class="text-sm text-neutral-700">{{
            'profile_dropdown_menu_language_label' | transloco
          }}</span>
          <span
            role="group"
            [attr.aria-label]="
              'profile_dropdown_menu_language_label' | transloco
            "
            class="flex gap-x-sm rounded-md bg-neutral-100 p-x-sm">
            @for (option of languages; track option) {
              <button
                type="button"
                [attr.data-lang]="option"
                [attr.lang]="option"
                [attr.aria-pressed]="lang() === option"
                [class]="
                  'whitespace-nowrap rounded-sm px-sm py-x-sm text-xs font-medium ' +
                  (lang() === option
                    ? 'bg-white text-neutral-900 shadow-xs'
                    : 'text-neutral-500 hover:text-neutral-900')
                "
                (click)="changeLanguage(option)">
                {{
                  (option === 'en'
                    ? 'navbar_language_dropdown_en'
                    : 'navbar_language_dropdown_ar'
                  ) | transloco
                }}
              </button>
            }
          </span>
        </li>
      </ul>
      <hr class="my-sm border-neutral-200" />
      <ul class="flex flex-col">
        @if (actions.reachablePortals().length === 2) {
          <li>
            <button
              type="button"
              data-item="portal"
              class="flex w-full px-lg py-sm text-start text-sm text-neutral-700 hover:bg-neutral-50"
              (click)="switchPortal(otherPortals()[0])">
              {{ goToLabel() | transloco }}
            </button>
          </li>
        } @else if (actions.reachablePortals().length > 2) {
          <li class="relative">
            <button
              type="button"
              data-item="portal"
              [attr.aria-expanded]="popup() === 'portal'"
              class="flex w-full items-center gap-sm px-lg py-sm text-start text-sm text-neutral-700 hover:bg-neutral-50"
              (click)="openPortals()">
              <span class="flex-1">{{
                'profile_menu_switch_portal_label' | transloco
              }}</span>
              <span class="truncate text-xs text-neutral-500">{{
                portalLabels[actions.currentPortal()] | transloco
              }}</span>
              <lib-chevron-right-icon iconClass="size-4 text-neutral-500" />
            </button>
            @if (popup() === 'portal') {
              <div
                data-portal-popup
                class="absolute bottom-0 start-full z-10 ms-sm w-64 rounded-lg border border-neutral-200 bg-white py-sm shadow-lg">
                <p class="px-lg pb-x-sm pt-sm text-xs text-neutral-500">
                  {{ 'profile_menu_switch_portal_label' | transloco }}
                </p>
                @for (portal of actions.reachablePortals(); track portal) {
                  <button
                    type="button"
                    [attr.data-portal]="portal"
                    [attr.aria-current]="
                      portal === actions.currentPortal() ? 'true' : null
                    "
                    class="flex w-full items-center px-lg py-sm text-start text-sm text-neutral-700 hover:bg-neutral-50"
                    (click)="switchPortal(portal)">
                    <span class="flex-1">{{
                      portalLabels[portal] | transloco
                    }}</span>
                    @if (portal === actions.currentPortal()) {
                      <span class="text-neutral-900" aria-hidden="true">✓</span>
                    }
                  </button>
                }
              </div>
            }
          </li>
        }
        <li>
          <button
            type="button"
            data-item="sign-out"
            class="flex w-full px-lg py-sm text-start text-sm text-destructive-500 hover:bg-neutral-50"
            (click)="signOut()">
            {{ 'sidenav_sign_out_item_label' | transloco }}
          </button>
        </li>
      </ul>
    </div>
  }
</div>
